// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Q1-z","colorTextValue":"R1-z","swatches":"S1-z","collapseLink":"T1-z","isCollapsed":"U1-z","dropdown":"V1-z","disabled":"W1-z"};